// Check minimum de quantité
function miniQuantity() {
  if (!!document.querySelector("#quantite-mini") === true){
    var total = parseInt(document.querySelector('.product .product-form__input label.total-nb .total-number').textContent);
    var minimumQuantity = parseInt(document.querySelector("#quantite-mini").textContent);
    if ( minimumQuantity <= total ){
      document.querySelector('.manque-quantite').style.cssText = "display: none !important;";
      document.querySelector('.product .product-form__input label.total-nb .total-number').style.cssText = "color: #000000;";
      if (!!document.querySelector('.product .btn-ajouter-au-devis[disabled]') === true){
        document.querySelector('.product .btn-ajouter-au-devis[disabled]').removeAttribute("disabled");
      }
    } else {
      document.querySelector('.product .btn-ajouter-au-devis').setAttribute("disabled", "true");
      document.querySelector('.manque-quantite').style.cssText = "display: block !important;";
      document.querySelector('.product .product-form__input label.total-nb .total-number').style.cssText = "color: #FF7530;";
    }
  } else if ( !!document.querySelector(".product .product-form__input label.total-nb .total-number") === true ){
    var total = parseInt(document.querySelector('.product .product-form__input label.total-nb .total-number').textContent);
    if ( total == 0){
      document.querySelector('.manque-quantite').style.cssText = "display: block !important;";
    } else {
      document.querySelector('.manque-quantite').style.cssText = "display: none !important;";
    }
  }
}


// Quantité produit dans panier
function nbProduitPanier() {
  if (!!document.querySelector("#app-quotes #omgrfq_button_action_snap button.omgrfq_view_quote") === true){
    var textQuoteBtn = document.querySelector("#app-quotes #omgrfq_button_action_snap button.omgrfq_view_quote").textContent;
    document.querySelector(".cart-count-bubble span").textContent = textQuoteBtn.replace('View Quote (', '').replace(')', '');
  }
}


// Ajout des "faux" boutons dans le devis
function addSecondaryBtn() {
  document.querySelector("#omgrfq-submit-quote-form .form-group.button-submit-quote").insertAdjacentHTML("afterbegin", '<a href="https://legoodgoodies.fr/collections/tous-les-produits" class="ajouter-autres-produits">Ajouter d\'autres produits</a><div class="valider-devis">Continuer</div>');
  document.querySelector("#omgrfq-submit-quote-form .form-group.button-submit-quote .valider-devis").onclick = function() {
    document.querySelector("html #omgrfq-submit-quote-form .omgrfq-form-wrapper .omgrfq-form").style.cssText = "display: flex;";
    document.querySelector("html .omgrfq-popup.omgrfq-popup-snap #submitOMGRFQForm").style.cssText = "display: block;";
    document.querySelector("#omgrfq-submit-quote-form .form-group.button-submit-quote .valider-devis").style.cssText = "display: none;";
    document.querySelector("#omgrfq-submit-quote-form .form-group.button-submit-quote .ajouter-autres-produits").style.cssText = "display: none;";
    
    const scrollContainer = document.querySelector('.omgrfq-content-scroll');
    const formElement = document.querySelector('.omgrfq-form');
    const scrollPosition = scrollContainer.scrollTop + (formElement.getBoundingClientRect().top - scrollContainer.getBoundingClientRect().top);
    scrollContainer.scrollTo({ top: scrollPosition, behavior: 'smooth' });

    const source = getCookie('form_source');
    const sourceInput = document.querySelector("html #omgrfq-submit-quote-form .form-group:nth-last-child(2) input");
    if (source && sourceInput) {
      sourceInput.value = source;
    }
  };
  /*document.querySelector("#omgrfq-submit-quote-form .form-group.button-submit-quote .ajouter-autres-produits").onclick = function() {
    document.querySelector("html .omgrfq-popup.omgrfq-popup-snap .omgrfq_continue_shopping").click();
  };*/
}


// Calcul du nombre minimum de produits
function changeNb() {
  var total = 0;
  document.querySelectorAll('.product .product-form__input:not(.couleur-variants):not(.product-form__quantity) label input[type="number"]').forEach(function(input) {
    total += parseFloat(input.value) || 0;
  });
  document.querySelector('.product .product-form__input:not(.couleur-variants):not(.product-form__quantity) label.total-nb .total-number').textContent = total;
  miniQuantity();
  event.preventDefault();
  let scrollPosition = window.scrollY;
  setTimeout(function () {
    window.scrollTo({top: scrollPosition, behavior: 'auto'});
  }, 10);
  setTimeout(function () {
    window.scrollTo({top: scrollPosition, behavior: 'auto'});
  }, 70);
}


// Activer le block de recherche
/*function activeSearch() {
  var width_screen = window.innerWidth;
  if (width_screen > 1400) {
    document.querySelector("details-modal.header__search details").setAttribute("open", "true");
  }else if (!!document.querySelector('details-modal.header__search details[open]') === true){
    document.querySelector("details-modal.header__search details").removeAttribute("open");
  }
}
activeSearch();
window.onresize = activeSearch;*/



const checkElementPresence = (selector) => {
  return new Promise((resolve, reject) => {
    const startTime = Date.now();
    const timeout = 5000;
    const interval = 200;
    
    const checkElement = () => {
      const element = document.querySelector(selector);
      
      if (element) {
        clearInterval(intervalId);
        resolve(element);
      } else if (Date.now() - startTime >= timeout) {
        clearInterval(intervalId);
        reject(new Error(`Element "${selector}" not found within ${timeout}ms`));
      }
    };
    
    const intervalId = setInterval(checkElement, interval);
  });
};


// Gestion du plugin Quote
window.addEventListener("load", (event) => {
  document.querySelector("span.header__icon.header__icon--cart").onclick = function() {
    document.querySelector("#app-quotes .omgrfq_view_quote").click();
    setTimeout(function () {
      document.addEventListener('click', function(event) {
        if (event.target.closest('#quote-data')) {
          setTimeout(function () {
            nbProduitPanier();
          }, 500);
        }
      });
    }, 500);

    checkElementPresence('#submitOMGRFQForm')
    .then(element => {
      document.querySelector("#submitOMGRFQForm").onclick = function() {
        const submitBtn = document.querySelector("#submitOMGRFQForm");
        
        if (submitBtn.hasAttribute('disabled')) {
          submitBtn.removeAttribute('disabled');
          setTimeout(function() {
            submitBtn.click();
            checkElementPresence('.omgrfq-submit-success')
            .then(element => {
              window.location.replace("https://legoodgoodies.fr/pages/merci");
            })
            .catch(error => {
              console.error(error.message);
            });
          }, 300);
          return;
        }
        
        checkElementPresence('.omgrfq-submit-success')
        .then(element => {
          window.location.replace("https://legoodgoodies.fr/pages/merci");
        })
        .catch(error => {
          console.error(error.message);
        });
      };
    })
    .catch(error => {
      console.error(error.message);
    });

    setTimeout(function () {
      addSecondaryBtn();
    }, 0);
  };
  
  nbProduitPanier();

  if (!!document.querySelector(".omgrfq-button .omgrfq-btn-quotes") === true){
    document.querySelector(".omgrfq-button .omgrfq-btn-quotes").onclick = function() {
      setTimeout(function () {
        nbProduitPanier();
      }, 1000);
    };
  }

  if (!!document.querySelector("html .omgrfq-popup.omgrfq-popup-snap .omgrfq_continue_shopping") === true){
    document.querySelector("html .omgrfq-popup.omgrfq-popup-snap .omgrfq_continue_shopping").onclick = function() {
      nbProduitPanier();
    };
  }

  if (!!document.querySelector("html .omgrfq-bg") === true){
    document.querySelector("html .omgrfq-bg").onclick = function() {
      nbProduitPanier();
    };
  }
});


// Click sur Ajouter au devis
if (!!document.querySelector(".product .btn-ajouter-au-devis.has-only-default-variant") === true){
  document.querySelector(".product .btn-ajouter-au-devis.has-only-default-variant").onclick = function() {
    if (!document.querySelector(".product .btn-ajouter-au-devis:not([disabled])").hasAttribute('disabled')) {
      var qtyProduct = parseInt(document.querySelector(".product .product-form__input:not(.couleur-variants):not(.product-form__quantity) label.total-nb .total-number").textContent);
      document.querySelector(".product .product-form__input.product-form__quantity input.quantity__input").value = qtyProduct;
      document.querySelector(".product .omgrfq-button .omgrfq-btn-quotes").click();
      setTimeout(function () {
        addSecondaryBtn();
      }, 0);
      checkElementPresence('#submitOMGRFQForm')
      .then(element => {
        document.querySelector("#submitOMGRFQForm").onclick = function() {
          checkElementPresence('.omgrfq-submit-success')
          .then(element => {
            window.location.replace("https://legoodgoodies.fr/pages/merci");
          })
          .catch(error => {
            console.error(error.message);
          });
        };
      })
      .catch(error => {
        console.error(error.message);
      });
    }
  };
}else if (!!document.querySelector(".product .btn-ajouter-au-devis") === true){
  document.querySelector(".product .btn-ajouter-au-devis").onclick = function() {

    // FELIX
    if ( document.querySelector('.total-nb .total-number').textContent == "0" ){
      document.querySelector('.manque-quantite').style.cssText = "display: block !important;";
    } else if (!document.querySelector(".product .btn-ajouter-au-devis:not([disabled])").hasAttribute('disabled')) {
      document.querySelector('.manque-quantite').style.cssText = "display: none !important;";
      if ( !!document.querySelector(".product-form__input input[name=Taille]") === true || !!document.querySelector(".product-form__input input[name=Pointure]") === true ){
        var input = document.querySelectorAll('.product-form__input--pill label input[type="number"]');
        var i = 0;
        function processInput() {
          if (i == 0){
            document.head.insertAdjacentHTML('beforeend', '<style id="styleAppQuote">#app-quotes #quote-data{display: none !important;}*{cursor: wait !important;}.pop-up-loading{display: flex !important;}</style>');
          }
          if (i < input.length) {
            if (parseInt(input[i].value) > 0) {
              var qtyProduct = parseInt(input[i].value);
              document.querySelector(".product .product-form__input.product-form__quantity input.quantity__input").value = qtyProduct;
              var variantTitle = "";
              document.querySelectorAll('.product fieldset.product-form__input').forEach(function(fieldset) {
                if (fieldset.classList.contains("couleur-variants") === true) {
                  var nameOption = fieldset.querySelector("input:checked").value;
                } else {
                  var nameOption = input[i].parentElement.querySelector(".value").getAttribute("value");
                }
                variantTitle += nameOption + " / ";
              });
              variantTitle = variantTitle.slice(0, -3);
    
              var script = document.getElementById("data-product");
              var jsonText = script.textContent.trim();
              var jsonData = JSON.parse(jsonText);
    
              var idVariant = null;
              for (var j = 0; j < jsonData.offers.length; j++) {
                if (jsonData.offers[j].variantName === variantTitle) {
                  idVariant = jsonData.offers[j].idVariant;
                  break;
                }
              }
    
              document.querySelector('product-form.product-form form input[name="id"]').value = idVariant;
              var currentUrl = window.location.href;
              var updatedUrl = currentUrl.replace(/variant=\d+/, "variant=" + idVariant);
              history.replaceState(null, null, updatedUrl);
              document.querySelector(".product button.omgrfq-btn-quotes").click();
    
              setTimeout(function () {
                document.querySelector("html .omgrfq-popup.omgrfq-popup-snap .omgrfq_continue_shopping").click();
              }, 400);
    
            }
            i++;
            setTimeout(processInput, 800);
          }else{
            document.querySelector("#app-quotes #omgrfq_button_action_snap button.omgrfq_view_quote").click();
            document.querySelector("#styleAppQuote").remove();
            setTimeout(function () {
              addSecondaryBtn();
            }, 0);
            nbProduitPanier();
            setTimeout(function () {
              document.addEventListener('click', function(event) {
                if (event.target.closest('#quote-data')) {
                  setTimeout(function () {
                    nbProduitPanier();
                  }, 500);
                }
              });
            }, 500);
            
            checkElementPresence('#submitOMGRFQForm')
            .then(element => {
              document.querySelector("#submitOMGRFQForm").onclick = function() {
                checkElementPresence('.omgrfq-submit-success')
                .then(element => {
                  window.location.replace("https://legoodgoodies.fr/pages/merci");
                })
                .catch(error => {
                  console.error(error.message);
                });
              };
            })
            .catch(error => {
              console.error(error.message);
            });
          }
        }
        processInput();
      }else{
        document.querySelector(".product .omgrfq-btn-quotes").click();
        setTimeout(function () {
          addSecondaryBtn();
        }, 0);
      }
    }
  };
}



var width_screen = window.innerWidth;
if (width_screen > 750) {
  var splideElements = document.querySelectorAll('.splide.reassurance-slider');
  splideElements.forEach(function(element) {
    var splideElementsLengths = element.querySelectorAll('.splide__slide').length;
    if ( splideElementsLengths > 4 ){
      var splide = new Splide(element, {
        type: 'loop',
        autoplay: true,
        autoWidth: true,
        interval: 3000,
        pauseOnHover: true,
        focus: 'left',
        speed: 1000,
        arrows: true,
        perPage: 4,
        direction: 'ltr',
        gap: '20px',
        pagination: false,
        easing: 'cubic-bezier(0.7, 0.01, 0.27, 0.99)',
        drag: true,
        breakpoints: {
          750: {
            focus: 'center',
          }
        }
      });
      splide.mount();
    }
  });
} else {
  var splideElements = document.querySelectorAll('.splide.reassurance-slider');
  splideElements.forEach(function(element) {
    var splide = new Splide(element, {
      type: 'loop',
      autoplay: true,
      autoWidth: true,
      interval: 3000,
      pauseOnHover: true,
      focus: 'center',
      speed: 1000,
      arrows: true,
      perPage: 1,
      direction: 'ltr',
      gap: '20px',
      pagination: false,
      easing: 'cubic-bezier(0.7, 0.01, 0.27, 0.99)',
      drag: true
    });
    splide.mount();
  });
}


if (!!document.querySelector('.shopify-section.shopify-section-group-header-group.announcement-bar-section .utility-bar .announcement-bar__link[href="#POPUP"]') === true){
  document.querySelector('.shopify-section.shopify-section-group-header-group.announcement-bar-section .utility-bar .announcement-bar__link[href="#POPUP"]').onclick = function() {
    document.querySelector(".pop-up-newsletter").style.cssText = "display: flex;";
  };
}


document.querySelectorAll('#FacetsWrapperDesktop .facets__summary.checkbox-facet').forEach(function(summury) {
  summury.setAttribute("aria-expanded", "true");
});


if (!!document.querySelector("header.header header-menu details") === true){
  const detailsElements = document.querySelectorAll('header.header header-menu details');

  detailsElements.forEach(details => {
    const summary = details.querySelector('summary');

    summary.addEventListener('mouseenter', () => {
      details.setAttribute('open', true);
    });

    details.addEventListener('mouseleave', () => {
      details.removeAttribute('open');
    });
  });
}

function ecoResponsableCheck() {
  if (!!document.querySelector('#FacetsWrapperMobile details[id*="eco-responsable"]') === true){
    setTimeout(function () {
      if (document.querySelector('#FacetsWrapperMobile details[id*="eco-responsable"] input.mobile-facets__checkbox').checked){
        if (!!document.querySelector(".style-eco-responsable") === false){
          document.head.insertAdjacentHTML('beforeend', "<style class='style-eco-responsable'>#FacetsWrapperMobile details[id*=eco-responsable] .mobile-facets__summary>div span:not(.mobile-facets__arrow):before{content: url(\"data:image/svg+xml; utf8, %3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_2791_4)'%3E%3Cpath d='M16 0H0V16H16V0Z' stroke='white' stroke-width='1.2'/%3E%3Cg clip-path='url(%23clip1_2791_4)'%3E%3Cpath d='M4.5 7.5L5.83333 8.75L7.16667 10L12.5 5' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_2791_4'%3E%3Crect width='16' height='16' fill='white'/%3E%3C/clipPath%3E%3CclipPath id='clip1_2791_4'%3E%3Crect width='11' height='7' fill='white' transform='translate(3 4)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A\");}</style>");
        }
      }else{
        if (!!document.querySelector(".style-eco-responsable") === true){
          document.querySelector(".style-eco-responsable").remove();
        }
      }
    }, 1500);
  }
}
ecoResponsableCheck();

if (!!document.querySelector('#FacetsWrapperMobile details[id*="eco-responsable"]') === true){
  document.querySelector('#FacetsWrapperMobile details[id*="eco-responsable"]').onclick = function() {
    document.querySelector('#FacetsWrapperMobile details[id*="eco-responsable"] .facets__label').click();
    ecoResponsableCheck();
  };
}



function fabriqueFranceCheck() {
  if (!!document.querySelector('#FacetsWrapperMobile details[id*="fabrique-en-france"]') === true){
    setTimeout(function () {
      if (document.querySelector('#FacetsWrapperMobile details[id*="fabrique-en-france"] input.mobile-facets__checkbox').checked){
        if (!!document.querySelector(".style-fabrique-en-france") === false){
          document.head.insertAdjacentHTML('beforeend', "<style class='style-fabrique-en-france'>#FacetsWrapperMobile details[id*=fabrique-en-france] .mobile-facets__summary>div span:not(.mobile-facets__arrow):before{content: url(\"data:image/svg+xml; utf8, %3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_2791_4)'%3E%3Cpath d='M16 0H0V16H16V0Z' stroke='white' stroke-width='1.2'/%3E%3Cg clip-path='url(%23clip1_2791_4)'%3E%3Cpath d='M4.5 7.5L5.83333 8.75L7.16667 10L12.5 5' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_2791_4'%3E%3Crect width='16' height='16' fill='white'/%3E%3C/clipPath%3E%3CclipPath id='clip1_2791_4'%3E%3Crect width='11' height='7' fill='white' transform='translate(3 4)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A\");}</style>");
        }
      }else{
        if (!!document.querySelector(".style-fabrique-en-france") === true){
          document.querySelector(".style-fabrique-en-france").remove();
        }
      }
    }, 1500);
  }
}
fabriqueFranceCheck();

if (!!document.querySelector('#FacetsWrapperMobile details[id*="fabrique-en-france"]') === true){
  document.querySelector('#FacetsWrapperMobile details[id*="fabrique-en-france"]').onclick = function() {
    document.querySelector('#FacetsWrapperMobile details[id*="fabrique-en-france"] .facets__label').click();
    fabriqueFranceCheck();
  };
}


document.addEventListener('DOMContentLoaded', function() {
  const menuItems = document.querySelectorAll('.menu-droite li');
  let currentHoveredItem = null;
  let removeTimeout = null;
  let isMenuOpen = false;
  let pendingItem = null; // Nouvel item en attente

  menuItems.forEach(item => {
    const megaMenu = item.querySelector('.mega-sous-menu');
    
    if (megaMenu) {
      // Au survol du li
      item.addEventListener('mouseenter', function() {
        // Si un menu est déjà ouvert et que ce n'est pas le même item
        if (isMenuOpen && currentHoveredItem !== item) {
          // Stocker l'item en attente
          pendingItem = item;
          
          // Si pas de timer en cours, démarrer la transition
          if (!removeTimeout) {
            startTransition();
          }
          return;
        }
        
        // Annuler le timeout de suppression si il existe
        if (removeTimeout) {
          clearTimeout(removeTimeout);
          removeTimeout = null;
          pendingItem = null;
        }
        
        // Fermer le menu précédent s'il existe
        if (currentHoveredItem && currentHoveredItem !== item) {
          const currentMegaMenu = currentHoveredItem.querySelector('.mega-sous-menu');
          if (currentMegaMenu) {
            currentMegaMenu.classList.remove('hover');
          }
        }
        
        // Ouvrir le nouveau menu
        megaMenu.classList.add('hover');
        currentHoveredItem = item;
        isMenuOpen = true;
        pendingItem = null;
      });
      
      // Quand on quitte le li
      item.addEventListener('mouseleave', function() {
        // Si c'est l'item en attente qui est quitté, l'annuler
        if (pendingItem === item) {
          pendingItem = null;
          return;
        }
        
        // Délai court pour vérifier si on va vers le mega-menu
        setTimeout(() => {
          checkIfShouldClose();
        }, 50);
      });
      
      // Maintenir ouvert si on survole le mega-menu
      megaMenu.addEventListener('mouseenter', function() {
        if (removeTimeout) {
          clearTimeout(removeTimeout);
          removeTimeout = null;
          pendingItem = null;
        }
      });
      
      // Quand on quitte le mega-menu
      megaMenu.addEventListener('mouseleave', function() {
        setTimeout(() => {
          checkIfShouldClose();
        }, 50);
      });
    }
  });
  
  function startTransition() {
    if (removeTimeout) {
      clearTimeout(removeTimeout);
    }
    
    removeTimeout = setTimeout(() => {
      // Fermer le menu actuel
      if (currentHoveredItem) {
        const currentMegaMenu = currentHoveredItem.querySelector('.mega-sous-menu');
        if (currentMegaMenu) {
          currentMegaMenu.classList.remove('hover');
        }
      }
      
      // Ouvrir le nouveau menu si l'item est encore survolé
      if (pendingItem && pendingItem.matches(':hover')) {
        const newMegaMenu = pendingItem.querySelector('.mega-sous-menu');
        if (newMegaMenu) {
          newMegaMenu.classList.add('hover');
          currentHoveredItem = pendingItem;
          isMenuOpen = true;
        }
      } else {
        currentHoveredItem = null;
        isMenuOpen = false;
      }
      
      pendingItem = null;
      removeTimeout = null;
    }, 300);
  }
  
  function checkIfShouldClose() {
    if (!currentHoveredItem) return;
    
    const item = currentHoveredItem;
    const megaMenu = item.querySelector('.mega-sous-menu');
    
    // Si on survole encore le li OU le mega-menu, on ne ferme pas
    if (item.matches(':hover') || megaMenu.matches(':hover')) {
      return;
    }
    
    // Si il n'y a pas d'item en attente, fermer normalement
    if (!pendingItem) {
      startCloseTimer();
    }
  }
  
  function startCloseTimer() {
    if (removeTimeout) {
      clearTimeout(removeTimeout);
    }
    
    removeTimeout = setTimeout(() => {
      if (currentHoveredItem) {
        const item = currentHoveredItem;
        const megaMenu = item.querySelector('.mega-sous-menu');
        
        // Double vérification avant de fermer
        if (!item.matches(':hover') && !megaMenu.matches(':hover')) {
          megaMenu.classList.remove('hover');
          currentHoveredItem = null;
          isMenuOpen = false;
        }
      }
      removeTimeout = null;
    }, 300);
  }
});






















document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.querySelector('.wrapper-menu-droite');
  if (wrapper){
    const fleches = wrapper.querySelectorAll('.fleche');
    const flecheGauche = fleches[0];
    const flecheDroite = fleches[1];
    const scrollAmount = 200;

    function updateFleches() {
      const scrollLeft = wrapper.scrollLeft;
      const scrollWidth = wrapper.scrollWidth;
      const clientWidth = wrapper.clientWidth;
      const maxScroll = scrollWidth - clientWidth;

      // Si le contenu n'est pas scrollable, cacher les deux flèches
      if (maxScroll <= 1) {
        flecheGauche.style.opacity = '0';
        flecheGauche.style.pointerEvents = 'none';
        flecheDroite.style.opacity = '0';
        flecheDroite.style.pointerEvents = 'none';
        return;
      }

      // Flèche gauche - masquer si au début
      if (scrollLeft <= 1) {
        flecheGauche.style.opacity = '0';
        flecheGauche.style.pointerEvents = 'none';
      } else {
        flecheGauche.style.opacity = '1';
        flecheGauche.style.pointerEvents = 'auto';
      }

      // Flèche droite - masquer si à la fin
      if (scrollLeft >= maxScroll - 1) {
        flecheDroite.style.opacity = '0';
        flecheDroite.style.pointerEvents = 'none';
      } else {
        flecheDroite.style.opacity = '1';
        flecheDroite.style.pointerEvents = 'auto';
      }
    }

    flecheGauche.addEventListener('click', function() {
      wrapper.scrollBy({
        left: -scrollAmount,
        behavior: 'smooth'
      });
    });

    flecheDroite.addEventListener('click', function() {
      wrapper.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    });

    wrapper.addEventListener('scroll', function() {
      updateFleches();
    });
    
    window.addEventListener('resize', updateFleches);

    setTimeout(updateFleches, 100);
  }




  document.querySelectorAll('.inline-richtext[telechargement]').forEach(function(element) {    
    element.addEventListener('click', function(e) {
      e.preventDefault();
      const fileUrl = this.getAttribute('telechargement');
      if (fileUrl) {
        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = '';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    });
  });
});



document.addEventListener('DOMContentLoaded', function() {
  const productFormInputs = document.querySelectorAll('.product-form__input');

  productFormInputs.forEach(input => {
    const labels = input.querySelectorAll('label');
    
    if (labels.length === 2) {
      const hasTotalNb = Array.from(labels).some(label => label.classList.contains('total-nb'));
      
      if (hasTotalNb) {
        const otherLabel = input.querySelector('label:not(.total-nb)');
        const totalNumber = input.querySelector('.total-nb .total-number');
        const inputField = otherLabel ? otherLabel.querySelector('input[type="number"]') : null;
        
        if (inputField) {
          inputField.setAttribute('min', '10');
          inputField.setAttribute('placeholder', '10');
          inputField.value = 10;
        }
        
        if (totalNumber) {
          totalNumber.textContent = 10;
        }
      }
    }
  });
  
  miniQuantity();
});



function toggleSearchOpen() {
  const details = document.querySelector('.header__search details');
  if (!details) return;
  if (window.innerWidth > 1400) {
    details.setAttribute('open', '');
  }
}

toggleSearchOpen();
window.addEventListener('resize', toggleSearchOpen);
























// =============================================
// STORAGE HELPERS
// =============================================

function setCookie(name, value, days = 7) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  document.cookie = name + "=" + encodeURIComponent(value) + ";" + expires + ";path=/";
}

function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
  }
  return null;
}

function setSourceStorage(value, days = 30) {
  window.__formSource = value;
  try { setCookie('form_source', value, days); } catch (e) {}
  try { sessionStorage.setItem('form_source', value); } catch (e) {}
  try { localStorage.setItem('form_source', value); } catch (e) {}
}

function getSourceStorage() {
  if (window.__formSource) return window.__formSource;
  const cookieVal = getCookie('form_source');
  if (cookieVal) return cookieVal;
  try {
    const session = sessionStorage.getItem('form_source');
    if (session) return session;
  } catch (e) {}
  try {
    const local = localStorage.getItem('form_source');
    if (local) return local;
  } catch (e) {}
  return null;
}

// =============================================
// MAPPING CAMPAGNES GOOGLE ADS (utm_campaign → source exacte)
// =============================================

const CAMPAIGN_MAP = {
  'eco-l': 'Campagne LGG - Search',
  'eco-r': 'Campagne LGG - Search',
  'pmge': 'Performance Max - Goodies express',
  'pm': 'Performance Max-1',
};

// =============================================
// TRAFFIC SOURCE DETECTION
// =============================================

function getCurrentDomain() {
  return window.location.hostname.replace('www.', '');
}

function isInternalReferrer() {
  const referrer = document.referrer;
  if (!referrer) return false;
  try {
    const referrerDomain = new URL(referrer).hostname.replace('www.', '');
    const currentDomain = getCurrentDomain();
    return referrerDomain === currentDomain || referrerDomain.includes('legoodgoodies');
  } catch (e) {
    return false;
  }
}

function detectTrafficSource() {
  const params = new URLSearchParams(window.location.search);
  const utmSource = params.get('utm_source') || '';
  const utmMedium = params.get('utm_medium') || '';
  const utmCampaign = params.get('utm_campaign') || '';
  const gclid = params.get('gclid');
  const gclau = params.get('_gcl_au');
  const kx = params.get('_kx');
  const referrer = document.referrer;

  // 1) PRIORITÉ ABSOLUE : campagne identifiée par utm_campaign
  const knownCampaign = CAMPAIGN_MAP[utmCampaign.toLowerCase()];
  if (knownCampaign) return knownCampaign;

  // 2) Trafic Google Ads sans campagne connue (gclid seul, etc.)
  if (gclid || gclau || utmMedium === 'cpc' || utmSource.toLowerCase() === 'google') {
    if (utmCampaign) return `Google Ads - ${utmCampaign}`;
    return 'Google Ads';
  }

  if (kx) return 'Klaviyo';

  const utmSourceMap = {
    'ig': 'Instagram',
    'instagram': 'Instagram',
    'fb': 'Facebook',
    'facebook': 'Facebook',
    'tiktok': 'TikTok',
    'pinterest': 'Pinterest',
    'youtube': 'YouTube',
    'twitter': 'Twitter/X',
    'linkedin': 'LinkedIn',
    'lemlist': 'Lemlist',
    'klaviyo': 'Klaviyo',
  };

  if (utmSource) {
    const mapped = utmSourceMap[utmSource.toLowerCase()];
    if (mapped) return mapped;
    const parts = [utmSource];
    if (utmMedium) parts.push(utmMedium);
    if (utmCampaign) parts.push(utmCampaign);
    return parts.join(' / ');
  }

  if (referrer && !isInternalReferrer()) {
    // Scanners de sécurité e-mail (pré-visitent les liens) → à ignorer
    const emailScanners = [
      'mailinblack',
      'safelinks.protection.outlook',
      'protection.office',
      'urldefense',   // Proofpoint
      'mimecast',
      'cudasvc',      // Barracuda
      'trendmicro',
    ];
    if (emailScanners.some(s => referrer.includes(s))) return null;

    const knownSources = [
      { match: 'google', name: 'Google (organique)' },
      { match: 'bing', name: 'Bing' },
      { match: 'yahoo', name: 'Yahoo' },
      { match: 'instagram', name: 'Instagram' },
      { match: 'l.instagram', name: 'Instagram' },
      { match: 'facebook', name: 'Facebook' },
      { match: 'tiktok', name: 'TikTok' },
      { match: 'pinterest', name: 'Pinterest' },
      { match: 'youtube', name: 'YouTube' },
      { match: 'twitter', name: 'Twitter/X' },
      { match: 't.co', name: 'Twitter/X' },
      { match: 'linkedin', name: 'LinkedIn' },
      { match: 'lnkd.in', name: 'LinkedIn' },
      { match: 'klaviyo', name: 'Klaviyo' },
      { match: 'klclick', name: 'Klaviyo' },
      { match: 'kl-', name: 'Klaviyo' },
      { match: 'chatgpt', name: 'ChatGPT' },
      { match: 'openai', name: 'ChatGPT' },
      { match: 'perplexity', name: 'Perplexity' },
      { match: 'claude.ai', name: 'Claude' },
      { match: 'anthropic', name: 'Claude' },
      { match: 'gemini.google', name: 'Gemini' },
      { match: 'bard.google', name: 'Gemini' },
      { match: 'copilot.microsoft', name: 'Copilot' },
    ];

    for (const s of knownSources) {
      if (referrer.includes(s.match)) {
        return s.name;
      }
    }

    try {
      return new URL(referrer).hostname.replace('www.', '');
    } catch (e) {}
  }

  if (isInternalReferrer()) return null;

  return 'Direct';
}

function saveTrafficSource() {
  const params = new URLSearchParams(window.location.search);
  const hasNewAttribution =
    params.get('gclid') ||
    params.get('_gcl_au') ||
    params.get('_kx') ||
    params.get('utm_source') ||
    params.get('utm_campaign') ||
    params.get('utm_medium');

  const existingSource = getSourceStorage();

  // Si on a déjà une source ET pas de nouveaux paramètres d'attribution → on garde
  if (existingSource && !hasNewAttribution) return;

  const newSource = detectTrafficSource();
  if (!newSource) return;

  // Ne pas écraser une campagne déjà identifiée par un "Google Ads" générique
  const knownCampaignNames = Object.values(CAMPAIGN_MAP);
  if (
    newSource === 'Google Ads' &&
    existingSource &&
    (existingSource.startsWith('Google Ads - ') || knownCampaignNames.includes(existingSource))
  ) {
    return;
  }

  setSourceStorage(newSource);
}

// =============================================
// CUSTOM CSS (formulaires secondaires + grand formulaire)
// =============================================

function frenchifyDateLabels(shadowRoot) {
  const replacements = { 'DD': 'JJ', 'YYYY': 'AAAA' };
  shadowRoot.querySelectorAll('[id="label-DD"], [id="label-YYYY"]').forEach(label => {
    const text = label.textContent.trim();
    if (replacements[text]) label.textContent = replacements[text];
  });
}

function injectCustomCSS(shadowRoot) {
  if (shadowRoot.querySelector('[data-custom-css]')) return;

  frenchifyDateLabels(shadowRoot);

  const style = document.createElement('style');
  style.setAttribute('data-custom-css', 'true');
  style.textContent = `
    button[data-testid="btn-form-submit"]{
      background-color: #618f6a !important;
      border-radius: 0 !important;
      font-size: 15px !important;
      font-weight: 600 !important;
    }

    ._formFieldContainer_1mxsl_5:has(input[id="custom#source"]),input[id="custom#source"],input[id="custom#source"]+label{
      display: none !important;
    }

    section>h2+div>p:first-child{
      margin-bottom: 10px;
      text-align: left;
      font-size: 24px;
      line-height: 1;
    }

    input[id*="pour_quelle_occasion"]{
      min-height: 70px !important;
    }

    input[id*="pour_quelle_occasion"]+label{
      top: 12.5px !important;
      line-height: 1.5;
    }

    input+label, textarea+label{
      font-size: 13px !important;
    }

    ._formFieldContainer_1mxsl_5:focus-within label{
      top: 8px !important;
    }

    section>h2+div>p:nth-child(2){
      text-align: center;
    }

    fieldset legend{
      margin-top: 10px !important;
      display: block !important;
      font-weight: 600 !important;
      font-size: 16px !important;
      line-height: 1.5 !important;
    }

    input[type="radio"]{
      accent-color: #000 !important;
    }

    fieldset[name*="recevoir"] legend{
      font-weight: 400 !important;
      font-size: 14px !important;
    }

    fieldset[name*="recevoir"]>legend+div{
      flex-direction: column;
      gap: 5px;
      margin-bottom: 10px;
    }

    fieldset label{
      word-break: normal;
    }

    section>h2+div._textBody_2aowh_10>p:first-child{
      text-align: center !important;
      font-size: 15.5px !important;
    }

    ._selectContainer_12thd_6>p{
      opacity: 0.6;
      font-size: 13px;
    }

    @media screen and (max-width: 880px){
      section>h2+div>p:first-child{
        font-size: 20px;
        line-height: 1.3;
      }
    }

    @media screen and (max-width: 750px){
      textarea+label._formInputFieldLabel_1mxsl_38{
        top: 10px !important;
        font-size: 11px !important;
      }

      input[id*="pour_quelle_occasion"]+label{
        font-size: 10.4px !important;
      }

      ._formFieldContainer_1mxsl_5:focus-within label {
        top: 13px !important;
      }

      ._formFieldContainer_1mxsl_5:focus-within textarea, ._formFieldContainer_1mxsl_5 ._inputFilled_1mxsl_74 textarea {
        padding-top: 40px !important;
      }
    }
  `;
  shadowRoot.appendChild(style);
}

// =============================================
// CUSTOM CSS (mini-formulaire 859064)
// =============================================

function injectMiniFormCSS(shadowRoot) {
  if (shadowRoot.querySelector('[data-mini-css]')) return;

  const textareaLabel = shadowRoot.querySelector('._formFieldContainer_1mxsl_5:has(textarea) label');
  const textarea = shadowRoot.querySelector('textarea._textArea_17mgw_1');
  if (textareaLabel && textarea) {
    textarea.setAttribute('placeholder', 'Ex : type de goodies/textiles souhaités, quantité, type d\'événement...');
    textareaLabel.textContent = 'Votre projet';
  }

  const emailInput = shadowRoot.querySelector('input#email');
  if (emailInput) {
    emailInput.setAttribute('placeholder', 'votre@email.com');
  }

  const style = document.createElement('style');
  style.setAttribute('data-mini-css', 'true');
  style.textContent = `
    ._formFieldContainer_1mxsl_5:has(input[id="custom#source"]),input[id="custom#source"],input[id="custom#source"]+label{
      display: none !important;
    }

    section h2._textHeading_2aowh_35{
      font-size: 32px !important;
      font-weight: 900 !important;
      text-align: center !important;
      line-height: 1.2 !important;
      margin-bottom: 0 !important;
    }

    section h2+div._textBody_2aowh_10 p{
      text-align: center !important;
      font-size: 15px !important;
      color: #666 !important;
      margin-bottom: 10px !important;
    }

    ._formInputFieldLabel_1mxsl_38,
    ._selectContainer_12thd_6>p._label_12thd_10{
      position: relative !important;
      top: auto !important;
      transform: none !important;
      font-size: 12px !important;
      font-weight: 700 !important;
      text-transform: uppercase !important;
      letter-spacing: 0.5px !important;
      color: #202020 !important;
      opacity: 1 !important;
      margin-bottom: 6px !important;
      pointer-events: none;
    }

    ._formFieldContainer_1mxsl_5:has(textarea){
      display: flex !important;
      flex-direction: column-reverse !important;
    }
      
    ._formFieldContainer_1mxsl_5:has(textarea)::before{
      content: none !important;
    }


    ._formFieldContainer_1mxsl_5:has(textarea) label{
      position: relative !important;
      top: auto !important;
      transform: none !important;
      margin-bottom: 6px !important;
      display: block !important;
      left: 0;
    }

    textarea._textArea_17mgw_1{
      min-height: 130px !important;
      padding: 15px !important;
      font-size: 14px !important;
      border-radius: 8px !important;
      background: #f5f5f5 !important;
      box-shadow: none !important;
      border: 1px solid #e0e0e0 !important;
    }

    textarea._textArea_17mgw_1::placeholder{
      color: #999 !important;
      font-size: 14px !important;
    }

    ._formFieldContainer_1mxsl_5:has(input#email){
      display: flex !important;
      flex-direction: column-reverse !important;
    }

    ._inline_1q1d2_47 ._formContainer_1q1d2_30{
      max-width: 600px !important;
    }

    ._formInputFieldLabel_1mxsl_38, ._selectContainer_12thd_6>p._label_12thd_10{
      margin-bottom: 0 !important;
    }

    ._formFieldContainer_1mxsl_5:has(input#email) label{
      position: relative !important;
      left: 0;
      top: -5px !important;
      transform: none !important;
      margin-bottom: 8px !important;
      display: block !important;
    }

    input._formInputField_nag3b_7{
      padding: 14px 15px !important;
      font-size: 14px !important;
      border-radius: 8px !important;
      background: #f5f5f5 !important;
      box-shadow: none !important;
      border: 1px solid #e0e0e0 !important;
    }

    input._formInputField_nag3b_7::placeholder{
      color: #999 !important;
      display: block !important;
      opacity: 1 !important;
    }

    ._formFieldContainer_1mxsl_5:focus-within label{
      top: auto !important;
      transform: none !important;
      font-size: 12px !important;
    }

    ._formFieldContainer_1mxsl_5:focus-within textarea,
    ._formFieldContainer_1mxsl_5:focus-within input._formInputField_nag3b_7{
      padding-top: 14px !important;
      background: #fff !important;
      border-color: #f5a623 !important;
      box-shadow: 0 0 0 2px rgba(245,166,35,0.2) !important;
    }

    ._selectContainer_12thd_6{
      display: flex !important;
      flex-direction: column !important;
    }

    ._selectContainer_12thd_6>p{
      opacity: 1 !important;
      font-size: 12px !important;
      font-weight: 700 !important;
      text-transform: uppercase !important;
      letter-spacing: 0.5px !important;
      color: #202020 !important;
      margin-bottom: 6px !important;
    }

    button._selectToggle_12thd_25{
      padding: 14px 15px !important;
      font-size: 14px !important;
      border-radius: 8px !important;
      background: #f5f5f5 !important;
      box-shadow: none !important;
      border: 1px solid #e0e0e0 !important;
    }

    form._formFieldset_cit2d_82{
      display: grid !important;
      grid-template-columns: 1fr 1fr !important;
      gap: 15px !important;
    }

    form._formFieldset_cit2d_82 > div:first-child{
      display: none !important;
    }

    form._formFieldset_cit2d_82 > ._formFieldContainer_1mxsl_5:has(textarea){
      grid-column: 1 / -1 !important;
    }

    form._formFieldset_cit2d_82 > ._selectContainer_12thd_6{
      grid-column: 1 !important;
    }

    form._formFieldset_cit2d_82 > ._formFieldContainer_1mxsl_5:has(input#email){
      grid-column: 2 !important;
    }

    button[data-testid="btn-form-submit"]{
      grid-column: 1 / -1 !important;
      background: linear-gradient(135deg, #E87D2D, #F6A523) !important;
      color: #fff !important;
      font-size: 16px !important;
      font-weight: 800 !important;
      text-transform: uppercase !important;
      letter-spacing: 1px !important;
      padding: 16px !important;
      border: none !important;
      border-radius: 10px !important;
      cursor: pointer !important;
      transition: transform 0.15s, box-shadow 0.15s !important;
    }

    ._selectToggleText_12thd_25:empty:before{
      content: "Sélectionnez" !important;
      color: #999 !important;
    }

    button[data-testid="btn-form-submit"]:hover{
      transform: translateY(-1px) !important;
      box-shadow: 0 4px 12px rgba(245,166,35,0.4) !important;
    }

    ._formDisclaimer_cit2d_38 p{
      text-align: center !important;
      font-size: 13px !important;
      color: #999 !important;
      margin-top: 8px !important;
    }

    ._formContainer_1q1d2_30{
      padding: 30px !important;
      border-radius: 12px !important;
    }

    @media screen and (max-width: 600px){
      form._formFieldset_cit2d_82{
        grid-template-columns: 1fr !important;
      }

      form._formFieldset_cit2d_82 > ._selectContainer_12thd_6,
      form._formFieldset_cit2d_82 > ._formFieldContainer_1mxsl_5:has(input#email){
        grid-column: 1 !important;
      }

      section h2._textHeading_2aowh_35{
        font-size: 24px !important;
      }
    }
  `;
  shadowRoot.appendChild(style);
}

// =============================================
// NATIVE VALUE SETTER (bypass Vue/React)
// =============================================

function setNativeValue(element, value) {
  const tagName = element.tagName.toLowerCase();
  const proto = tagName === 'textarea' ? window.HTMLTextAreaElement.prototype : window.HTMLInputElement.prototype;
  const valueSetter = Object.getOwnPropertyDescriptor(proto, 'value').set;
  valueSetter.call(element, value);
  element.dispatchEvent(new Event('input', { bubbles: true }));
  element.dispatchEvent(new Event('change', { bubbles: true }));
}

// =============================================
// BUDGET SELECT HELPER
// =============================================

function selectBudgetOption(shadowRoot, budgetValue) {
  const budgetButton = shadowRoot.querySelector('button[aria-controls*="budget"]');
  if (!budgetButton) return false;

  const isExpanded = budgetButton.getAttribute('aria-expanded') === 'true';
  if (!isExpanded) budgetButton.click();

  setTimeout(() => {
    const dropdown = budgetButton.querySelector(`div:nth-child(3)`);
    setTimeout(function () {
      if (dropdown) {
        const options = dropdown.querySelectorAll('[role="option"]');
        options.forEach(option => {
          if (option.textContent.trim() === budgetValue) option.click();
        });
      }
    }, 100);
  }, 200);

  return true;
}

// =============================================
// FILL SOURCE DANS UN SHADOW ROOT SHOPIFY FORMS
// =============================================

function fillShopifyFormSource(formRootSelector) {
  const tryFill = () => {
    const formRoot = document.querySelector(formRootSelector);
    if (!formRoot) return false;

    const embedElement = formRoot.querySelector('shopify-forms-embed#app-embed');
    if (!embedElement || !embedElement.shadowRoot) return false;

    const shadowRoot = embedElement.shadowRoot;
    injectCustomCSS(shadowRoot);

    const source = getSourceStorage() || 'Direct';
    const sourceInput = shadowRoot.querySelector('#custom\\#source');
    if (sourceInput) {
      sourceInput.value = source;
      sourceInput.dispatchEvent(new Event('input', { bubbles: true }));
      sourceInput.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    return false;
  };

  if (tryFill()) return;
  const interval = setInterval(() => {
    if (tryFill()) clearInterval(interval);
  }, 500);
}

// =============================================
// SAVE (mini-formulaire 859064)
// =============================================

function saveFormDataToCookies() {
  const trySetup = () => {
    const formRoot = document.querySelector('div[data-forms-id="forms-root-859064"]');
    if (!formRoot) return false;

    const embedElement = formRoot.querySelector('shopify-forms-embed#app-embed');
    if (!embedElement || !embedElement.shadowRoot) return false;

    const shadowRoot = embedElement.shadowRoot;
    if (shadowRoot.querySelector('[data-mini-css]')) return true;

    injectMiniFormCSS(shadowRoot);

    const besoinField = shadowRoot.querySelector('textarea[name*="autres_prcisions"], textarea[name*="besoin"], #custom\\#autres_prcisions_champ_libre_parlez-nous_de_votre_projet');
    if (besoinField) {
      besoinField.addEventListener('input', (e) => setCookie('form_besoin', e.target.value));
    }

    const budgetButton = shadowRoot.querySelector('button[aria-controls*="budget"]');
    if (budgetButton) {
      const budgetTextSpan = budgetButton.querySelector('._selectToggleText_12thd_25');
      if (budgetTextSpan) {
        const observer = new MutationObserver(() => {
          const budgetText = budgetTextSpan.textContent;
          if (budgetText && budgetText.trim()) setCookie('form_budget', budgetText.trim());
        });
        observer.observe(budgetTextSpan, { childList: true, characterData: true, subtree: true });
      }
    }

    const emailField = shadowRoot.querySelector('#email, input[type="email"]');
    if (emailField) {
      emailField.addEventListener('input', (e) => setCookie('form_email', e.target.value));
    }

    // Injection de la source aussi dans ce formulaire
    const source = getSourceStorage() || 'Direct';
    const sourceInput = shadowRoot.querySelector('#custom\\#source');
    if (sourceInput) {
      sourceInput.value = source;
      sourceInput.dispatchEvent(new Event('input', { bubbles: true }));
      sourceInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    return true;
  };

  if (trySetup()) return;
  const interval = setInterval(() => {
    if (trySetup()) clearInterval(interval);
  }, 500);
}

// =============================================
// FILL (grand formulaire - shadow root 198069)
// =============================================

function fillFormFromCookies() {
  const besoin = getCookie('form_besoin');
  const budget = getCookie('form_budget');
  const email = getCookie('form_email');
  const source = getSourceStorage();

  const tryFill = () => {
    const formRoot = document.querySelector('div[data-forms-id="forms-root-198069"]');
    if (!formRoot) return false;

    const embedElement = formRoot.querySelector('shopify-forms-embed#app-embed');
    if (!embedElement || !embedElement.shadowRoot) return false;

    const shadowRoot = embedElement.shadowRoot;
    injectCustomCSS(shadowRoot);

    let fieldsUpdated = false;

    if (besoin) {
      const besoinInput = shadowRoot.querySelector('#custom\\#pour_quelle_occasion_voulez-vous_faire_appel__nous_ftes_cadeau_c');
      if (besoinInput && !besoinInput.value) {
        besoinInput.value = besoin;
        besoinInput.dispatchEvent(new Event('input', { bubbles: true }));
        besoinInput.dispatchEvent(new Event('change', { bubbles: true }));
        fieldsUpdated = true;
      }
    }

    if (budget) {
      setTimeout(() => selectBudgetOption(shadowRoot, budget), 500);
      fieldsUpdated = true;
    }

    if (email) {
      const emailInput = shadowRoot.querySelector('#email');
      if (emailInput && !emailInput.value) {
        emailInput.value = email;
        emailInput.dispatchEvent(new Event('input', { bubbles: true }));
        emailInput.dispatchEvent(new Event('change', { bubbles: true }));
        fieldsUpdated = true;
      }
    }

    if (source) {
      const sourceInput = shadowRoot.querySelector('#custom\\#source');
      if (sourceInput) {
        sourceInput.value = source;
        sourceInput.dispatchEvent(new Event('input', { bubbles: true }));
        sourceInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (fieldsUpdated) {
      setTimeout(() => {
        const elementPosition = formRoot.getBoundingClientRect().top + window.pageYOffset;
        const isMobile = window.innerWidth <= 768;
        const offset = isMobile ? 70 : 160;
        window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' });
      }, 1000);
    }

    return true;
  };

  if (tryFill()) return;
  const interval = setInterval(() => {
    if (tryFill()) clearInterval(interval);
  }, 500);
}

// =============================================
// FIX EMAIL PATTERN (Chrome 124+ /v mode regex)
// =============================================

function fixOmgEmailPattern() {
  const emailInput = document.querySelector('#omgrfq-form_6');
  if (emailInput && emailInput.getAttribute('pattern')) {
    const currentPattern = emailInput.getAttribute('pattern');
    if (currentPattern.includes('[A-Za-z0-9._%+-]')) {
      emailInput.setAttribute('pattern', '[^@\\s]+@[^@\\s]+\\.[^@\\s]+');
    }
  }
}

// =============================================
// FILL SOURCE (formulaire OMG RFQ) - VERSION ROBUSTE
// =============================================

function fillOmgRfqSource() {
  function getSource() {
    return getSourceStorage() || 'Direct';
  }

  function fillSourceIfEmpty() {
    const sourceInput = document.querySelector('#omgrfq-form_9');
    if (!sourceInput) return false;
    const source = getSource();
    if (sourceInput.value.trim() === source) return true;
    setNativeValue(sourceInput, source);
    return true;
  }

  const globalObserver = new MutationObserver(() => {
    fillSourceIfEmpty();
    fixOmgEmailPattern();
  });
  globalObserver.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('focusin', function (e) {
    if (e.target.closest('.omgrfq-form')) {
      setTimeout(fillSourceIfEmpty, 50);
      setTimeout(fillSourceIfEmpty, 300);
    }
  });

  document.addEventListener('input', function (e) {
    if (e.target.closest('.omgrfq-form') && e.target.id !== 'omgrfq-form_9') {
      fillSourceIfEmpty();
    }
  });

  document.addEventListener('click', function (e) {
    const target = e.target;
    if (target.matches('#submitOMGRFQForm, .valider-devis') || target.closest('#submitOMGRFQForm, .valider-devis')) {
      fillSourceIfEmpty();
    }
  }, true);

  document.addEventListener('submit', function (e) {
    if (e.target.id === 'omgrfq-quote-list-form') {
      fillSourceIfEmpty();
    }
  }, true);

  function injectSourceInBody(body) {
    const source = getSource();

    if (body instanceof FormData) {
      const current = body.get('omgrfq-form_9');
      if (!current || !String(current).trim()) {
        body.set('omgrfq-form_9', source);
      }
      return body;
    }

    if (body instanceof URLSearchParams) {
      const current = body.get('omgrfq-form_9');
      if (!current || !current.trim()) {
        body.set('omgrfq-form_9', source);
      }
      return body;
    }

    if (typeof body === 'string') {
      try {
        const json = JSON.parse(body);
        if (json && typeof json === 'object') {
          let modified = false;
          if ('omgrfq-form_9' in json && (!json['omgrfq-form_9'] || !String(json['omgrfq-form_9']).trim())) {
            json['omgrfq-form_9'] = source;
            modified = true;
          } else if (!('omgrfq-form_9' in json) && (json.form_data || json.formData || json.fields)) {
            const container = json.form_data || json.formData || json.fields;
            if (typeof container === 'object' && (!container['omgrfq-form_9'] || !String(container['omgrfq-form_9']).trim())) {
              container['omgrfq-form_9'] = source;
              modified = true;
            }
          } else if (!('omgrfq-form_9' in json)) {
            json['omgrfq-form_9'] = source;
            modified = true;
          }
          if (modified) return JSON.stringify(json);
          return body;
        }
      } catch (e) {}

      if (body.includes('omgrfq-form_9=') || body.includes('omgrfq-form')) {
        const params = new URLSearchParams(body);
        const current = params.get('omgrfq-form_9');
        if (!current || !current.trim()) {
          params.set('omgrfq-form_9', source);
          return params.toString();
        }
      }
    }

    return body;
  }

  function isOmgRequest(url, body) {
    const urlStr = String(url || '');
    if (urlStr.includes('omgrfq') || urlStr.includes('quote') || urlStr.includes('rfq')) return true;
    if (body instanceof FormData && body.has('omgrfq-form_9')) return true;
    if (body instanceof URLSearchParams && body.has('omgrfq-form_9')) return true;
    if (typeof body === 'string' && body.includes('omgrfq-form')) return true;
    return false;
  }

  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    try {
      const [url, options] = args;
      if (options && options.body && isOmgRequest(url, options.body)) {
        const newBody = injectSourceInBody(options.body);
        if (newBody !== options.body) {
          args[1] = { ...options, body: newBody };
        }
      }
    } catch (e) {}
    return originalFetch.apply(this, args);
  };

  const originalXHROpen = XMLHttpRequest.prototype.open;
  const originalXHRSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this._omg_url = url;
    return originalXHROpen.call(this, method, url, ...rest);
  };

  XMLHttpRequest.prototype.send = function (body) {
    try {
      if (body && isOmgRequest(this._omg_url, body)) {
        body = injectSourceInBody(body);
      }
    } catch (e) {}
    return originalXHRSend.call(this, body);
  };
}

// =============================================
// SHOPIFY FORMS - SURVEILLANCE GLOBALE
// =============================================

function watchShopifyForms() {
  const formIds = [
    { selector: 'div[data-forms-id="forms-root-859064"]', handler: saveFormDataToCookies },
    { selector: 'div[data-forms-id="forms-root-198069"]', handler: fillFormFromCookies },
    { selector: 'div[data-forms-id="forms-root-778313"]', handler: () => fillShopifyFormSource('div[data-forms-id="forms-root-778313"]') },
    { selector: 'div[data-forms-id="forms-root-543049"]', handler: () => fillShopifyFormSource('div[data-forms-id="forms-root-543049"]') },
  ];

  const handled = new Set();

  const checkAll = () => {
    formIds.forEach(({ selector, handler }) => {
      if (handled.has(selector)) return;
      if (document.querySelector(selector)) {
        handled.add(selector);
        handler();
      }
    });
  };

  checkAll();

  const observer = new MutationObserver(checkAll);
  observer.observe(document.body, { childList: true, subtree: true });
}

// =============================================
// INIT
// =============================================

function initFormHandling() {
  saveTrafficSource();
  watchShopifyForms();
  fillOmgRfqSource();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFormHandling);
} else {
  initFormHandling();
}